import React from 'react';

function ConnectCnt() {
  return <div>ConnectCnt</div>;
}

export default ConnectCnt;
